module.exports = __webpack_public_path__ + "static/media/order_mecano.37c4cee2.gif";